<template>
  <div class="pay-panel">
    <ConfirmModal ref="confirmModal"></ConfirmModal>

    <div class="content">
      <div class="merchant-row">
        <div class="merchant-avatar" :class="{ 'is-channel': !!channelIcon }" style="display: flex;align-items: center;justify-content: center;" >
          <img :src="merchantAvatar" alt="" />
        </div>
        <div class="merchant-name" style="margin-left: 0.06rem;">{{ merchantName }}</div>
        <span v-if="selectUrl" class="mch-switch" @click="switchMerchant">
          <img class="mch-switch-ico" src="https://agent.fskeeper.com/img/cashier_merchant.png" alt="" />
          切换
        </span>
      </div>

      <div class="amount-card">
        <div class="amount-label">付款金额</div>
        <div class="amount-line">
          <span class="amount-symbol">￥</span>
          <div class="input-c">
            <div class="input-c-div-1">{{ formatMoney(amount) }}</div>
            <div class="input-c-div" :style="'background:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"></div>
          </div>
        </div>
        <div class="remark-input" @click="myDialogStateFn(remark)">
          <span v-if="remark">{{ remark }}</span>
          <span v-else>添加备注</span>
        </div>
      </div>

      <div class="brand-logo">
        <img
          class="brand-logo-img"
          src="https://agent.fskeeper.com/img/乘鱼掌柜（黑色字体）.png"
          alt="乘鱼掌柜"
        />
      </div>
    </div>
    <MyDialog
        v-show="myDialogState"
        @myDialogStateFn="myDialogStateFn"
        :remark="remark"
        :typeColor="typeColor[payType]"
    >
    </MyDialog>

    <div class="keyboard-plus" v-if="isAllowModifyAmount">
      <Keyboard
          @delTheAmount="delTheAmount"
          @conceal="conceal"
          @enterTheAmount="enterTheAmount"
          @clearTheAmount="clearTheAmount"
          @payment="payment"
          @paymentAndInvoice="paymentAndInvoice"
          :money="money"
          :concealSate="concealSate"
          :typeColor="typeColor[payType]"
          :touchTypeColor="touchTypeColor[payType]"
          :invoiceEnabled="invoiceEnabled"
      ></Keyboard>
    </div>

    <div class="bnt-pay" v-if="!isAllowModifyAmount">
      <div class="bnt-pay-group">
        <div
            class="bnt-pay-text"
            :style="'background:' + typeColor[payType] + ';'"
            @click="pay"
        >
          付款
        </div>
        <div
            v-if="invoiceEnabled"
            class="bnt-pay-text-outline"
            :style="'color:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"
            @click="payAndInvoice"
        >
          付款+开票
        </div>
      </div>
    </div>

    <div v-if="paying" class="pay-loading-mask">
      <div class="pay-loading-box">
        <div class="pay-loading-spinner" :style="'border-top-color:' + typeColor[payType] + ';'"></div>
        <div class="pay-loading-text">处理中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDialog from "./../dialog/dialog";
import Keyboard from "./../keyboard/keyboard";
import { getPayPackage, getPayOrderInfo, getMyTransactions, cancelPay } from '@/api/api'
import config from "@/config";
import wayCodeUtils from '@/utils/wayCode'
import microMerchantSwitch from '@/mixins/microMerchantSwitch'
import channelAvatar from '@/mixins/channelAvatar'
export default {
  components: { MyDialog, Keyboard },
  mixins: [microMerchantSwitch, channelAvatar],
  data: function () {
    return {
      merchantName: '乘鱼掌柜',
      avatar: require("../../assets/icon/wx.svg"),
      amount: "",
      resData: {},
      payImg: require("../../assets/icon/wx.svg"),
      payOrderInfo: {},
      isAllowModifyAmount: true,
      myDialogState: false,
      remark: "",
      money: -1,
      concealSate: true,
      paying: false,
      payType: "wxpay",
      invoiceEnabled: false,
      fromInvoice: false,
      invoiceList: [],
      transactionList: [],
      showInvoiceList: false,
      showTransactionList: false,
      // 商户推广引流：抖音/快手/小红书链接拼接文案，下单（点付款手势）时复制到剪贴板
      promoCopyText: '',
      typeColor: {
        alipay: "#1678ff",
        wxpay: "#07c160",
        ysfpay: "#ff534d"
      },
      touchTypeColor: {
        alipay: "rgba(20, 98, 206, 1)",
        wxpay: "rgba(7, 130, 65, 1)",
        ysfpay: "rgb(248 70 65, 1)"
      },
    }
  },
  mounted() {
    this.fromInvoice = this.$route.query.fromInvoice === '1';
    this.loadInvoiceRecords();
    this.fetchMyTransactions();
    this.setPayOrderInfo();
  },
  methods: {
    loadInvoiceRecords() {
      this.invoiceList = JSON.parse(sessionStorage.getItem('invoiceRecords') || '[]');
      if (this.invoiceList.length > 0) this.showInvoiceList = true;
    },
    fetchMyTransactions() {
      const that = this;
      getMyTransactions(50).then(list => {
        that.transactionList = Array.isArray(list) ? list : [];
        if (that.transactionList.length > 0) that.showTransactionList = true;
      }).catch(() => {
        that.transactionList = [];
      });
    },
    formatTxnYuan(amountFen) {
      if (amountFen == null || amountFen === '') return '0.00';
      const n = Number(amountFen);
      if (isNaN(n)) return String(amountFen);
      return (n / 100).toFixed(2);
    },
    formatTxnTime(item) {
      const raw = item.successTime || item.createdAt || item.createTime;
      if (!raw) return '';
      const d = new Date(raw);
      if (isNaN(d.getTime())) return String(raw);
      return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0') + ' ' +
          String(d.getHours()).padStart(2, '0') + ':' +
          String(d.getMinutes()).padStart(2, '0');
    },
    payment() {
      if (this.money == -1) {
        return;
      }
      this.pay();
    },
    paymentAndInvoice() {
      if (this.money == -1) {
        return;
      }
      this.goInvoicePage();
    },
    conceal() {
      this.concealSate = !this.concealSate
    },
    enterTheAmount(item) {
      if (this.amount >= 9999999
          || (item === "." && this.amount.includes("."))
          || (this.amount.includes(".") && this.amount.split(".").pop().length >= 2)
      ) {
        return;
      }
      if (this.amount === "0") {
        this.amount = item.toString();
      } else {
        this.amount = `${this.amount}${item}`;
      }
      if (this.amount === ".") {
        this.amount = "0.";
      }
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    delTheAmount() {
      this.amount = this.amount.substring(0, this.amount.length - 1)
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    clearTheAmount(){
      this.amount = "";
      this.payOrderInfo.amount = 0;
      this.money = -1;
    },
    formatMoney(money) {
      let part = money.toString().split('.');
      let l = part[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      let r = part.length > 1 ? `.${part.pop()}` : '';
      return `${l}${r}`
    },
    myDialogStateFn: function (remark) {
      this.remark = remark;
      this.myDialogState = !this.myDialogState;
    },
    setPayOrderInfo(){
      const that = this
      getPayOrderInfo().then(res => {
        that.payOrderInfo = res
        that.merchantName = res.mchName
        that.bindMicroSelectUrl(res)
        that.bindChannelAvatar(res)
        that.promoCopyText = that.buildPromoCopyText(res.promotion)
        that.amount = Number(res.amount) > 0 ? (res.amount / 100) + "" : ""
        that.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1
        that.isAllowModifyAmount = res.fixedFlag !== 1
        that.invoiceEnabled = !!res.invoiceEnabled
        if (res.payOrderId && !that.fromInvoice) {
          const fixedRoute = wayCodeUtils.getFixedRouteName()
          if (fixedRoute) {
            that.$router.replace({ name: fixedRoute })
          }
          return
        }
      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    payAndInvoice: function () {
      this.goInvoicePage();
    },
    goInvoicePage() {
      this.$router.push({
        name: 'CashierInvoice',
        query: { amount: this.amount, payType: this.payType, remark: this.remark }
      });
    },
    buildPromoCopyText(promo) {
      if (!promo) return '';
      const parts = [];
      if (promo.douyinVideoUrl) parts.push('抖音：' + promo.douyinVideoUrl);
      if (promo.kuaishouVideoUrl) parts.push('快手：' + promo.kuaishouVideoUrl);
      if (promo.xiaohongshuVideoUrl) parts.push('小红书：' + promo.xiaohongshuVideoUrl);
      return parts.join('\n');
    },
    copyToClipboard(text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      }
      return Promise.resolve(this.fallbackCopy(text));
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    },
    handlePayCancel() {
      const close = () => window.WeixinJSBridge.call('closeWindow');
      cancelPay(this.resData.payOrderId).then(data => {
        if (data && data.paid) {
          this.$confirm({ title: '提示', content: '支付已完成', typeColor: this.typeColor[this.payType], onOk: close });
          return;
        }
        if (data && data.pending) {
          this.$confirm({
            title: '支付结果确认中',
            content: '支付结果尚未确定，请稍后查看订单，请勿重复支付。',
            typeColor: this.typeColor[this.payType],
            onOk: close
          });
          return;
        }
        this.$confirm({ title: '提示', content: '支付已取消', typeColor: this.typeColor[this.payType], onOk: close });
      }).catch(() => {
        this.$confirm({
          title: '支付结果确认中',
          content: '支付结果尚未确定，请稍后查看订单，请勿重复支付。',
          typeColor: this.typeColor[this.payType],
          onOk: close
        });
      });
    },
    pay: function () {
      if (this.paying) return;
      let that = this;
      this.paying = true;
      // 在用户点击「付款」的手势上下文中复制推广链接（此时剪贴板写入最可靠），
      // 支付完成后用户即可直接到抖音/快手/小红书粘贴打开。
      if (this.promoCopyText) {
        this.copyToClipboard(this.promoCopyText);
      }
      getPayPackage(this.amount, this.remark).then(res => {
        that.paying = false;
        if (res.code && res.code != '0') {
          return that.$confirm({ title: '请求失败', content: res.msg, typeColor: that.typeColor[that.payType] });
        }
        if (res.orderState != 1) {
          return that.$confirm({ title: '订单异常', content: res.errMsg, typeColor: that.typeColor[that.payType] });
        }
        that.resData = res;
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
          }
        } else {
          that.onBridgeReady();
        }
      }).catch(res => {
        that.paying = false;
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}});
      });
    },
    onBridgeReady() {
      let that = this;
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', JSON.parse(that.resData.payInfo),
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              if (that.payOrderInfo.returnUrl) {
                location.href = that.payOrderInfo.returnUrl;
              } else {
                that.$confirm({
                  title: '提示',
                  content: '支付已完成',
                  typeColor: that.typeColor[that.payType],
                  onOk: () => window.WeixinJSBridge.call('closeWindow')
                });
              }
            }
            if (res.err_msg == "get_brand_wcpay_request:cancel") {
              that.handlePayCancel()
            }
            if (res.err_msg == "get_brand_wcpay_request:fail") {
              that.$confirm({
                title: '支付失败',
                content: res.err_msg || JSON.stringify(res),
                typeColor: that.typeColor[that.payType],
                onOk: () => window.WeixinJSBridge.call('closeWindow')
              });
            }
            if (res.err_msg == "total_fee") {
              that.$confirm({
                title: '参数错误',
                content: '缺少必要参数',
                typeColor: that.typeColor[that.payType],
                onOk: () => window.WeixinJSBridge.call('closeWindow')
              });
            }
          }
      );
    },
  }
}
</script>
<style lang="css" scoped>
@import './pay.css';

.pay-loading-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.pay-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  gap: 14px;
}
.pay-loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e0e0e0;
  border-top-color: #07c160;
  border-radius: 50%;
  animation: pay-spin 0.8s linear infinite;
}
.pay-loading-text {
  font-size: 14px;
  color: #555;
}
@keyframes pay-spin {
  to { transform: rotate(360deg); }
}
</style>
